import React from 'react';
import { ScrollArea } from './ui/scroll-area';
import { Badge } from './ui/badge';
import { Target, ShieldAlert, Clock, ShoppingCart, XCircle, Bell } from 'lucide-react';

const alertIcons = {
  TARGET_HIT: Target,
  STOP_LOSS: ShieldAlert,
  EXPIRED: Clock,
  BOUGHT: ShoppingCart,
  CLOSED: XCircle,
};

const alertColors = {
  success: 'text-emerald-400',
  danger: 'text-red-400',
  warning: 'text-[hsl(var(--primary))]',
  info: 'text-[hsl(var(--info))]',
};

export const AlertsStream = ({ alerts = [], unreadCount = 0, onMarkRead }) => {
  return (
    <div className="bg-[hsl(var(--card))] border border-[hsl(var(--border))] rounded-xl p-4" data-testid="alerts-stream">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <h3 className="text-sm font-semibold tracking-wide uppercase text-[hsl(var(--muted-foreground))]">
            Alerts
          </h3>
          {unreadCount > 0 && (
            <Badge className="bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))] text-[10px] px-1.5 py-0">
              {unreadCount}
            </Badge>
          )}
        </div>
        {unreadCount > 0 && (
          <button
            onClick={onMarkRead}
            className="text-xs text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--foreground))] transition-colors"
          >
            Mark all read
          </button>
        )}
      </div>

      <ScrollArea className="h-[240px]">
        {alerts.length === 0 ? (
          <div className="flex flex-col items-center justify-center h-full text-[hsl(var(--muted-foreground))]">
            <Bell className="w-8 h-8 mb-2 opacity-30" />
            <p className="text-sm">No alerts yet</p>
          </div>
        ) : (
          <div className="space-y-2 pr-2">
            {alerts.map((alert, idx) => {
              const Icon = alertIcons[alert.type] || Bell;
              const colorClass = alertColors[alert.severity] || 'text-[hsl(var(--muted-foreground))]';
              return (
                <div
                  key={alert._id || idx}
                  className={`p-3 rounded-lg border border-[hsl(var(--border))] bg-[hsl(var(--surface-2))] ${
                    !alert.read ? 'border-l-2 border-l-[hsl(var(--primary))]' : ''
                  }`}
                  data-testid="alerts-stream-item"
                >
                  <div className="flex items-start gap-2">
                    <Icon className={`w-4 h-4 mt-0.5 flex-shrink-0 ${colorClass}`} />
                    <div className="flex-1 min-w-0">
                      <p className="text-sm leading-snug">{alert.message}</p>
                      <p className="text-[10px] text-[hsl(var(--muted-foreground))] mt-1 font-mono">
                        {alert.created_at ? new Date(alert.created_at).toLocaleString() : ''}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </ScrollArea>
    </div>
  );
};
